import { useCallback, useEffect, useState } from "react";
import shallowEqual from "shallow-equal/objects";

export type UpdatePreview = (preview: string | null, file: File | null, isLoading?: boolean) => void;

type MetaPreview = [Preview, UpdatePreview];

export type Preview = {
  src?: string;
  file?: File | null;
  resourcePreview?: string;
  isLoading?: boolean;
};

export const DEFAULT_PREVIEW: Preview = {
  src: "",
  file: null,
  resourcePreview: null,
};

export const useMetaPreview = (resourcePreview: Preview): MetaPreview => {
  const [preview, setPreviewState] = useState(DEFAULT_PREVIEW);

  useEffect(() => {
    if (!shallowEqual(resourcePreview, preview)) {
      setPreviewState(resourcePreview);
    }
  }, [resourcePreview.src]);

  const setPreview = useCallback(
    (src: string | null, file: File | null, isLoading?: boolean) => setPreviewState({ src, file, isLoading }),
    [setPreviewState],
  );

  return [preview, setPreview];
};
